// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IAddress,
}                               from '../interfaces';

const getUserAddresses = async ({
    test,
}: {
    test: boolean,
}): Promise<IAddress[] | null> => {
    const functions = getFunctions();
    const handleGetUserAddresses = httpsCallable<
        Record<
            string,
            boolean
        >,
        IAddress[] | null
    >(
        functions,
        'getUserAddresses',
    );
    return handleGetUserAddresses({
        test,
    }).then((result) => {
        const addresses = result.data as IAddress[] | null;
        return addresses;
    }).catch((err) => {
        throw err;
    });
};

export default getUserAddresses;
